export class StepperDetails {
    public stepName: string;
    public stepTitle: string;
    public active: boolean;
    public completed: boolean;
    public previousStepName: string;
    public isFirstStep = false;
    constructor(stepName: string, stepTitle: string, active: boolean, completed: boolean = false) {
        this.stepName = stepName;
        this.stepTitle = stepTitle;
        this.active = active;
        this.completed = completed;
    }
  }
  